import * as Sentry from '@sentry/react-native';

import { OralExamSessionPhase } from '@/common/api/models/oralExamSessionPhase';

const TAG_KEYS = [
  'oral.slot_id',
  'oral.booking_id',
  'oral.role',
  'oral.phase',
  'oral.question_index',
] as const;

export type OralExamSentryTagsInput = {
  slotId: string;
  bookingId?: string;
  phase?: OralExamSessionPhase;
  questionIndex?: number;
};

/**
 * Attach opaque oral-exam context to Sentry events (D9 — no user ids or LiveKit identities).
 */
export function setOralExamSentryTags({
  slotId,
  bookingId,
  phase,
  questionIndex,
}: OralExamSentryTagsInput): void {
  Sentry.setTag('oral.slot_id', slotId);
  Sentry.setTag('oral.role', 'lecturer');
  Sentry.setTag('oral.booking_id', bookingId ?? undefined);
  Sentry.setTag('oral.phase', phase ?? undefined);
  Sentry.setTag(
    'oral.question_index',
    questionIndex !== undefined ? String(questionIndex) : undefined,
  );
}

/** Clears every oral-exam tag this module sets. */
export function clearOralExamSentryTags(): void {
  TAG_KEYS.forEach((key) => {
    Sentry.setTag(key, undefined);
  });
}
